import { UserAvatar } from '@/graphql/schema'

export type PresenceAvatar = UserAvatar

const presenceAvatarValues = new Set<string>(Object.values(UserAvatar))

export function isPresenceAvatar(value: unknown): value is PresenceAvatar {
  return typeof value === 'string' && presenceAvatarValues.has(value)
}

export function normalizePresenceAvatar(
  avatar: unknown,
): PresenceAvatar | null {
  return isPresenceAvatar(avatar) ? avatar : null
}
